import { Pipe, PipeTransform } from '@angular/core';

/**
 * This pipe can be used for applying component's methods to values in template.
 *
 * Created for fixing templates, which are using explicit function calls for displayed
 * values and therefore resulting excessive change detection.
 *
 * In a typical case the components should be built so, that the values are provided directly
 * from the component's logic (x.component.ts) for the view (x.component.html) and using this
 * pipe isn't encouraged when creating new functionality to the app.
 */
@Pipe({
  name: 'applyFunction',
  pure: true
})
export class ApplyFunctionPipe implements PipeTransform {
  /**
   * @param func Remember to use arrow function if it uses 'this' inside of it.
   * @param args Remember that changes made inside composite objects are not detected
   * by angular, and you have to notify for them with the ChangeDetectionRef
   */
  public transform = (func: (...params: any[]) => any, ...params: any[]): any => func(...params);
}
